import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import classNames from 'classnames';
import * as React from 'react';
import { CsatToggle } from './components/CsatToggle';
import styles from './index.module.scss';
const headersDictionary = {
    email: 'CSAT for Email & Contact Form',
    widgetchat: 'CSAT for Chat',
    messenger: 'CSAT for Messenger',
    pstnphone: 'CSAT for Phone',
};
const descriptionsDictionary = {
    email: 'Turn this on to start sending a Customer Satisfaction email whenever an Email or Contact Form conversation is closed. In the settings below you can specify which contact points should be enabled and customize your surveys.',
    widgetchat: 'Turn this on to show a Customer Satisfaction survey whenever a chat conversation is closed. In the settings below you can customize your surveys.',
    messenger: 'Turn this on to show a Customer Satisfaction survey whenever a chat conversation is closed in Messenger widget. In the settings below you can customize your surveys.',
    pstnphone: 'Turn this on to show a Customer Satisfaction survey whenever a call conversation is closed in Dixa. In the settings below you can customize your surveys.',
};
export const GlobalCsatSwitch = (props) => {
    const humanReadableHeader = headersDictionary[props.channel];
    const humanReadableDescription = descriptionsDictionary[props.channel];
    return (_jsxs("div", Object.assign({ className: classNames(styles.root, {
            [styles.rootDisabled]: props.disabled,
        }) }, { children: [_jsxs("div", Object.assign({ className: styles.description }, { children: [_jsx("h2", Object.assign({ className: styles.header }, { children: humanReadableHeader })), _jsx("div", Object.assign({ className: styles.subHeader }, { children: humanReadableDescription }))] })), _jsx(CsatToggle, { id: `global-switch-${props.channel}`, channel: props.channel, isActive: props.isActive, onChange: props.onChange })] })));
};
